import PropTypes from "prop-types";

export function authAccess_person(person, user, userAsiakas) {
  let response = { read: false, edit: false };
  if (!user) return response;
  if (person == null) return response;
  if (user.personId == person.personId) return { read: true, edit: true };

  if (userAsiakas?.asiakasId === person?.ownerAsiakasId) {
    if (userAsiakas.auth.edit || userAsiakas.auth.originalEdit) return { read: true, edit: true };
    if (userAsiakas.auth.isAsiakasEditor) return { read: true, edit: true };
    if (userAsiakas.auth.isAsiakasAdmin) return { read: true, edit: true };
    if (user.isAnyAdmin) return { read: true, edit: true };
    return { read: true, edit: false };
  }
  return response;
}

authAccess_person.propTypes = {
  person: PropTypes.object,
  user: PropTypes.object,
  userAsiakas: PropTypes.object,
};
